import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { IonContent } from '@ionic/angular';
import { first } from 'rxjs/operators';
import { Navigator } from 'src/app/services/routing/navigator';
import { AppLinksService } from 'src/app/services/applinks/app-links.service';
import { isUndefined } from 'src/app/services/codeUtils';
import { ConfigService } from 'src/app/services/config/config.service';
import { EventsService } from 'src/app/services/event/event.service';
import { LogoutService } from 'src/app/services/logout/logout.service';
import { UserSessionService } from 'src/app/services/user-session/user-session.service';

@Component({
  selector: 'app-update-privacy-policy',
  templateUrl: './update-privacy-policy.component.html',
  styleUrls: ['./update-privacy-policy.component.scss'],
})
export class UpdatePrivacyPolicyComponent implements OnInit {
  @Input() customerId: any;
  @Input() callback: () => void;
  @ViewChild('Content') content: IonContent;

  public error = null;
  public buttonDisabled = false;
  public feautureCustomerSupportURL: string;
  public timerId: any;

  constructor(
    public events: EventsService,
    private userSession: UserSessionService,
    private config: ConfigService,
    private appLinks: AppLinksService,
    private navigator:Navigator,
    private logoutService:LogoutService
  ) {
    this.events.publish("event:lobby:hide");

    this.timerId = setTimeout(()=> {
      this.closeModal();
    },300000);
  }

  ngOnInit() {
    this.feautureCustomerSupportURL = this.config.getConfig().FEATURE_CUSTOMER_SUPPORT_URL || '';
  }

  public onAgree() {
    this.buttonDisabled = true;
    this.userSession.acceptPrivacyPolicy(this.customerId).pipe(first()).subscribe(
      response => {
        if (!isUndefined(response) && !!response.result) {
          if (!!this.callback) {
            this.callback();
            this.events.publish("event:lobby:show");
            this.navigator.dismiss();
          }
          clearTimeout(this.timerId);
        } else {
          this.logoutService.onLogout({reason:'TOC_INVALID'});
        }
      },
      error => this.logoutService.onLogout({reason:'TOC_INVALID'})
    )
  }

  openMatchedExternalLinks(code, title){
    return this.appLinks.openMatchedExternalLinksPopover(code, title)
  }

  goToFeautureCustomerSupportURL() {
      this.appLinks.openExternalPage(this.feautureCustomerSupportURL);
      return false;
  }

  closeModal = () => {
    this.navigator.dismiss();
    this.logoutService.onLogout({reason:'TOC_INVALID'});
  }

}
